import { render } from "./Form.vue?vue&type=template&id=f4a612ca&scoped=true"
import script from "./Form.vue?vue&type=script&lang=js"
export * from "./Form.vue?vue&type=script&lang=js"

import "./Form.vue?vue&type=style&index=0&id=f4a612ca&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-f4a612ca"

export default script